import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingJpgToBmpConfig } from '@/data/landingConfig/landingJpgToBmpConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_JpgToBmp } from './schemaObject';

interface Props {}
const JpgToBmpConverter: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_JpgToBmp} />
			<LandingTemplate
				data={landingJpgToBmpConfig}
				funnelLinkService={GenerateLandingLinkService.funnelImageConverter()}
			/>
		</>
	);
};

export default JpgToBmpConverter;
